import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-677624c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "up-website-link" }
const _hoisted_2 = ["href"]

import { computed } from 'vue'

import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import { useAppStore } from '@/popup/store/AppStore'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { UNIVERSAL_CLOUD_URL } from '@/shared/config'


export default /*#__PURE__*/_defineComponent({
  __name: 'UPWebsiteLink',
  setup(__props) {

const appStore = useAppStore()
const universalProfilesLink = computed(
  () =>
    `${UNIVERSAL_CLOUD_URL}/${appStore.currentProfile.address}` +
    `?network=${appStore.network.id}`
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Tooltip, {
      value: _ctx.$t('website_link.tooltip'),
      "offset-distance": "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", {
          href: encodeURI(universalProfilesLink.value),
          target: "_blank",
          rel: "noopener noreferer"
        }, [
          _createVNode(SvgIcon, {
            height: "24",
            width: "24",
            name: "up-website-link",
            color: "var(--neutral-100)"
          })
        ], 8 /* PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["value"])
  ]))
}
}

})